var SENTRY_RELEASE;SENTRY_RELEASE={name: "Horméia", version: "1.2.0"};